import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { TYPO, S, SHADCN } from '../theme';
import IconButton from './IconButton';

// ── <MoisSelector> — navigation mois précédent/suivant, bloquée au mois courant.
// Sélecteur unique du design system : utilisé par Comptabilité, Monitoring et
// Top ventes. `mois` au format 'YYYY-MM', `onChange` reçoit le nouveau 'YYYY-MM'.

const MOIS_FR = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

const currentMois = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

const shiftMois = (mois, delta) => {
  const [y, m] = mois.split('-').map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

export default function MoisSelector({ mois, onChange, style }) {
  const isCurrentMonth = mois === currentMois();
  const [y, m] = mois.split('-');
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: S[2], marginBottom: S[5], ...style }}>
      <IconButton aria-label="Mois précédent" onClick={() => onChange(shiftMois(mois, -1))}>
        <ChevronLeft size={18} />
      </IconButton>
      <div style={{ minWidth: 150, display: 'flex', justifyContent: 'center', alignItems: 'baseline', gap: 6 }}>
        <span style={{ ...TYPO.subhead, color: SHADCN.fg }}>{MOIS_FR[parseInt(m, 10) - 1]}</span>
        <span style={{ ...TYPO.body, ...TYPO.num, color: SHADCN.mutedFg }}>{y}</span>
      </div>
      <IconButton aria-label="Mois suivant" onClick={() => !isCurrentMonth && onChange(shiftMois(mois, 1))} disabled={isCurrentMonth}>
        <ChevronRight size={18} />
      </IconButton>
    </div>
  );
}
